import classNames from 'classnames';
import PersonaSelect from '../PersonaSelect';
import styles from './PersonaForm.module.css';
import type { PersonaRowData } from 'admin/types';
import { MultiSelect } from 'admin/shared-components/MultiSelect/MultiSelect';
import { Input } from 'admin/shared-components/Input/Input';

type BasePersonaInputProps = {
  disabled?: boolean;
  dataTestId?: string;
  optionName: string;
  label: string;
  id: string;
  skip?: boolean;
};

type DropDownInput = BasePersonaInputProps & {
  type: 'multiSelect';
  listOptions?: { label: string; value: string }[];
  value?: string[];
  onInputChange: (e: string[]) => void;
  placeholder?: string;
  customOnSearch?: (search: string) => void;
  customOnValueChange?: (value: { label: string; value: string }[]) => void;
};

type TextInput = BasePersonaInputProps & {
  type: 'input';
  value?: string;
  onInputChange: (e: string) => void;
};

type SelectInput = BasePersonaInputProps & {
  type: 'select';
  value?: string;
  onInputChange: (e: PersonaRowData) => void;
  placeholder?: string;
};

export type Inputs = DropDownInput | TextInput | SelectInput;

export default function buildInput(inputProps: Inputs) {
  switch (inputProps.type) {
    case 'input':
      return (
        <>
          <label htmlFor={inputProps.optionName} className={classNames(styles.personaLabel)}>
            {inputProps.label}
          </label>
          <div className={classNames(styles.personaChild)}>
            <Input
              id={inputProps.id}
              disabled={inputProps.disabled}
              value={inputProps.value}
              onInputChange={(e) => inputProps.onInputChange(e.target.value)}
              dataTestId={inputProps.dataTestId}
            />
          </div>
        </>
      );
    case 'multiSelect':
      return (
        <>
          <label htmlFor={inputProps.id} className={classNames(styles.personaLabel)}>
            {inputProps.label}
          </label>
          <div className={classNames(styles.personaChild)}>
            <MultiSelect
              id={inputProps.id}
              allowApplyAll={true}
              dataTestId={inputProps.dataTestId}
              disabled={inputProps.disabled}
              onChange={inputProps.onInputChange}
              options={inputProps.listOptions || []}
              placeholder={inputProps.placeholder}
              value={inputProps.value}
              customOnSearch={inputProps.customOnSearch}
              customOnValueChange={inputProps.customOnValueChange}
            />
          </div>
        </>
      );
    case 'select':
      return (
        <>
          <label htmlFor={inputProps.id} className={classNames(styles.personaLabel)}>
            {inputProps.label}
          </label>
          <div className={classNames(styles.personaChild)}>
            <PersonaSelect
              id={inputProps.id}
              dataTestId={inputProps.dataTestId}
              onChange={inputProps.onInputChange}
              placeholder={inputProps.placeholder}
            />
          </div>
        </>
      );
    default:
      return <div>Not implemented yet.</div>;
  }
}
